<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { calculateYearsPerPosition, formatTotalYearsSimple } from "@/utils/proposalValidation.js";

export default {
    name: "ResumeTemp6",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: {
        resume: { type: Object, required: true },
        pageGap: { type: Boolean, default: true },
        startPage: { type: Number, default: 1 },
    },
  data() {
    return {
      memberPages: []
    };
 },
    computed: {},
    methods: {
        calculateYearsPerPosition,
        formatTotalYearsSimple,
		async m_getResumeData(teamMemberId) {
		    let resumeData=await this.$store.dispatch('getResumeData', teamMemberId);
		    return resumeData;
		},
  async m_memberPages() {
    const membersWithData = [];

    for (const member of this.resume.members) {
        let resumeData = await this.m_getResumeData(member.teamMemberId);

        let parsedResumeData = resumeData;
        if (typeof parsedResumeData === 'string') {
            try {
                parsedResumeData = JSON.parse(parsedResumeData);
            } catch (e) {
                parsedResumeData = null;
            }
        }

        membersWithData.push({
            ...member,
            parsedResumeData
        });
    }

    const pages = [];
    for (let i = 0; i < membersWithData.length; i += 2) {
        pages.push(membersWithData.slice(i, i + 2));
    }

    this.memberPages = pages;
}		
 		
    },
watch: {
  'resume.members': {
    deep: true,
    immediate: true,
    handler() {
      this.m_memberPages();
    }
  },
  'resume.members.length'(val) {
    if (val > 0) this.m_memberPages();
  },
  '$store.state.members.data': {
    deep: true,
    handler() {
      this.m_memberPages();
    }
  }
}		
};
</script>

<template>
  <div class="main-container" :style="{
    gap: pageGap ? '20px' : '0px',
    '--header-color': resume.style.colorScheme.header || '#1a237e',
    '--body-color': resume.style.colorScheme.body || '#ffffff',
    '--footer-color': resume.style.colorScheme.footer || '#1a237e',
    '--heading-color': resume.style.heading.color || '#333333',
    '--heading-size': (resume.style.heading.size || 24) + 'px',
    '--heading-weight-bold': resume.style.heading.bold ? '900' : 'bold',
    '--heading-weight': resume.style.heading.bold ? 'bold' : 'normal',
    '--heading-style': resume.style.heading.italic ? 'italic' : 'normal',
    '--heading-decoration': resume.style.heading.underline ? 'underline' : 'none',
    '--heading-font': resume.style.heading.font || 'Helvetica',
    '--label-color': resume.style.label.color || '#666666',
    '--label-size': (resume.style.label.size || 14) + 'px',
    '--label-weight': resume.style.label.bold ? 'bold' : 'normal',
    '--label-weight-bold': resume.style.label.bold ? '900' : 'bold',
    '--label-style': resume.style.label.italic ? 'italic' : 'normal',
    '--label-decoration': resume.style.label.underline ? 'underline' : 'none',
    '--label-font': resume.style.label.font || 'Helvetica',
    '--text-color': resume.style.text.color || '#333333',
    '--text-size': (resume.style.text.size || 12) + 'px',
    '--text-weight': resume.style.text.bold ? 'bold' : 'normal',
    '--text-style': resume.style.text.italic ? 'italic' : 'normal',
    '--text-decoration': resume.style.text.underline ? 'underline' : 'none',
    '--text-font': resume.style.text.font || 'Helvetica',
  }">
    <div v-for="(pageMembers, pageIndex) in memberPages" :key="pageIndex" class="profile-container page-unit">
      <!-- TOP BANNER (Per Page) -->
      <div class="header-banner banner">
        <div class="header-content">
          <h2 class="header-title">
            <SpellCheckedText :value="resume.title || 'B. Proposed Team'" @input="resume.title = $event" />
          </h2>
          <div class="header-logo photobox">
            <PhotoBox :project="resume" type="logo" bgColor="transparent" objectFit="contain" />
          </div>
        </div>
      </div>

      <div class="members-layout">
        <div v-for="(member, mIndex) in pageMembers" :key="mIndex" class="member-unit">
          <div class="cv-content-wrapper">
            <!-- SIDEBAR (Left) -->
            <div class="sidebar">
              <div class="profile-image-container">
                <PhotoBox v-if="member" class="photobox" :project="member" :bgColor="resume.style.colorScheme.body"
                  type="profile" />
              </div>

              <div class="sidebar-details">
                <div class="sidebar-section">
                  <h4 class="section-label">YEARS OF EXPERIENCE</h4>
                  <div v-if="member.parsedResumeData && member.parsedResumeData.positions && member.parsedResumeData.positions.length > 0">
                    <p class="section-value">
                      <SpellCheckedText :value="member.parsedResumeData.positions[0].company || ''"
                        @input="member.parsedResumeData.positions[0].company = $event" />
                      <span v-if="member.parsedResumeData.positions[0].company">: </span>
                      <SpellCheckedText
                        :value="member.parsedResumeData.positions[0].calculatedYears !== undefined ? member.parsedResumeData.positions[0].calculatedYears : calculateYearsPerPosition(member.parsedResumeData.positions[0])"
                        @input="member.parsedResumeData.positions[0].calculatedYears = $event" />
                    </p>

                    <p class="section-value">
                      Industry: {{ formatTotalYearsSimple(member.parsedResumeData.positions) }}
                    </p>
                  </div>
                </div>

                <div class="sidebar-section">
                  <h4 class="section-label">EDUCATION</h4>
                  <div v-if="member.parsedResumeData && member.parsedResumeData.education && member.parsedResumeData.education.length > 0">
                    <p v-for="(edu, i) in ((member.parsedResumeData && member.parsedResumeData.education) || [])" :key="'edu-' + i"
                      class="section-value">
                      <SpellCheckedText :value="edu.degree || ''" @input="edu.degree = $event" />
                      <span v-if="edu.degree && (edu.field || edu.school)">, </span>
                      <SpellCheckedText :value="edu.field || ''" @input="edu.field = $event" />
                      <br v-if="edu.school" />
                      <SpellCheckedText :value="edu.school || ''" @input="edu.school = $event" />
                      <span v-if="edu.year"> ({{ edu.year }})</span>
                    </p>
                  </div>
                </div>

                <div class="sidebar-section certifications-sec">
                  <h4 class="section-label">LICENSES/<br />REGISTRATIONS/<br />CERTIFICATIONS</h4>
                  <div
                    v-if="(member.parsedResumeData && member.parsedResumeData.certifications && member.parsedResumeData.certifications.length > 0) || (member.certifications && member.certifications.length > 0)">
                    <div
                      v-for="(cert, cIndex) in (((member.parsedResumeData && member.parsedResumeData.certifications) || member.certifications || []).slice(0, 2))"
                      :key="'cert-' + cIndex" class="section-value">
                      <SpellCheckedText :value="cert.name || cert || ''"
                        @input="cert.name !== undefined ? cert.name = $event : member.certifications[cIndex] = $event" />
                      <span v-if="cert.issuer">-
                        <SpellCheckedText :value="cert.issuer" @input="cert.issuer = $event" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- MAIN CONTENT (Right) -->
            <div class="main-body">
              <div class="personal-info">
                <h1 class="member-name">
                  <SpellCheckedText :value="member.teamMemberName || 'N/A'" @input="member.teamMemberName = $event" />,
                </h1>
                <h2 class="member-role">
                  <SpellCheckedText :value="member.role || 'N/A'" @input="member.role = $event" />
                </h2>
              </div>

              <div class="projects-section">
                <div v-for="(project, pIndex) in (member.projects || []).slice(0, 3)" :key="pIndex"
                  class="project-item">
                  <h4 class="project-title">
                    <SpellCheckedText :value="project.projectName || 'N/A'" @input="project.projectName = $event" />
                    <span v-if="project.city || project.stateProvince"> -
                      <SpellCheckedText :value="project.city || ''" @input="project.city = $event" />,
                      <SpellCheckedText :value="project.stateProvince || ''" @input="project.stateProvince = $event" />
                    </span>
                  </h4>
                  <p class="project-desc">
                    <SpellCheckedText :value="project.projectDetails || 'N/A'"
                      @input="project.projectDetails = $event" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="footer-bottom">
        <div class="footer-content">
          <div class="footer-left">
            <div class="footer-line" />
            <p class="footer-text">{{ resume.opprName }}</p>
          </div>
          <div class="footer-right">
            <div class="page-badge">{{ String(startPage + pageIndex).padStart(2, '0') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  display: flex;
  flex-direction: column;
  width: 211mm;
  min-height: 296.83mm;
  position: relative;
  box-sizing: border-box;
  background: white;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .profile-container {
    display: flex;
    flex-direction: column;
    height: 296.83mm;
    overflow: hidden;
    position: relative;
    padding: 0;

    .banner {
      height: 100px;
      display: flex;
      align-items: center;
      padding: 0 50px;

      &.header-banner {
        background: var(--header-color);
      }
    }

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .header-title {
        color: white;
        font-size: 16px;
        font-weight: 700;
        margin: 0;
        font-family: Helvetica;
      }

      .header-logo {
        height: 80px;
        width: 120px;
      }
    }

    .members-layout {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;

      .member-unit {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        padding: 20px 50px;

        .cv-content-wrapper {
          flex: 1;
          display: flex;
          gap: 30px;
          min-height: 0;

          .sidebar {
            width: 28%;
            display: flex;
            flex-direction: column;

            .profile-image-container {
              width: 100%;
              height: 150px;
              background: var(--body-color);
              overflow: hidden;
              margin-bottom: 15px;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .pictureBox {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                width: 100%;
                height: 100%;

                .head {
                  background: white;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                }

                .body {
                  background: white;
                  width: 70px;
                  height: 50px;
                  border-top-left-radius: 50%;
                  border-top-right-radius: 50%;
                }
              }
            }

            .sidebar-section {
              min-height: 40px;
              margin-bottom: 10px;

              .section-label {
                font-size: var(--label-size);
                font-weight: var(--label-weight);
                font-family: var(--label-font);
                font-style: var(--label-style);
                text-decoration: var(--label-decoration);
                color: var(--label-color);
                margin-bottom: 5px;
                text-transform: uppercase;
              }

              .section-value {
                font-size: var(--text-size);
                font-weight: var(--text-weight);
                font-family: var(--text-font);
                font-style: var(--text-style);
                text-decoration: var(--text-decoration);
                color: var(--text-color);
                margin-bottom: 4px;
                line-height: 1.2;
              }

              &.certifications-sec {
                overflow: hidden;
              }

            }
          }

          .main-body {
            width: 72%;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;

            .personal-info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 150px;

              .member-name {
                font-size: var(--heading-size);
                font-weight: var(--heading-weight-bold);
                font-family: var(--heading-font);
                font-style: var(--heading-style);
                text-decoration: var(--heading-decoration);
                color: var(--heading-color);
                margin-bottom: 5px;
              }

              .member-role {
                font-size: var(--heading-size);
                font-weight: var(--heading-weight);
                font-family: var(--heading-font);
                font-style: var(--heading-style);
                text-decoration: var(--heading-decoration);
                color: var(--heading-color);
                margin: 0;
              }
            }

            .projects-section {
              flex: 1;
              display: flex;
              flex-direction: column;
              min-height: 0;
              margin-top: 15px;

              .project-item {
                .project-title {
                  font-size: var(--label-size);
                  font-weight: var(--label-weight);
                  font-family: var(--label-font);
                  font-style: var(--label-style);
                  text-decoration: var(--label-decoration);
                  color: var(--label-color);
                  margin-bottom: 2px;
                }

                .project-desc {
                  font-size: var(--text-size);
                  font-weight: var(--text-weight);
                  font-family: var(--text-font);
                  font-style: var(--text-style);
                  text-decoration: var(--text-decoration);
                  color: var(--text-color);
                  line-height: 1.2;
                  margin-bottom: 20px;
                }
              }
            }
          }
        }
      }
    }

    .footer-bottom {
      margin-top: auto;
      padding-bottom: 30px;

      .footer-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .footer-left {
          flex: 1;
          margin: 0 20px 0px 50px;

          .footer-line {
            height: 2px;
            background: var(--footer-color);
          }

          .footer-text {
            margin-top: 5px;
            margin-bottom: 0px;
            font-size: 12px;
            color: black;
            font-family: Helvetica;
          }
        }

        .footer-right {
          .page-badge {
            background: var(--footer-color);
            color: white;
            padding: 6px 60px 6px 20px;
            font-size: 10px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
